<template>
  <section class="flex align-middle justify-center sm:py-40">
    <Card class="w-full max-w-448 p-24">
      <h1 class="text-h1 mb-16">Upgrade request sent</h1>
      <p class="pb-16 text-body text-grey-body">
        Our Customer Success team will validate your request. You will receive a confirmation email in 1-2 business days.
      </p>
      <Button class="w-full" variant="primary" value="Continue" size="medium" @click="redirectToDash" />
    </Card>
  </section>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';
import { redirect } from '@/helpers/redirects';

export default {
  name: 'UpgradeRequestSent',
  components: {
    Card,
    Button,
  },
  methods: {
    redirectToDash() {
      redirect('/account/seekers/dashboard');
    },
  },
};
</script>
